// libs
import React, { memo, useState } from 'react';
import { styled } from '@nykaa/ui-components';

// components
import SubSection from './SubSection';

// helpers
import { validateEmail } from 'shared/components/Footer/components/Subscription/helpers';

// constants
import { TEXTS } from 'shared/components/Footer/constants';
import { FONTS } from 'shared/styles/base';

// apis
import { subscribeNewsletter } from 'shared/api/misc';

// styles
const Container = styled.div`
  .sb-form {
    display: flex;
    font-family: ${FONTS.BASE_FAMILY};
    ${({ theme }) => theme.typography.bodyLarge};
    align-items: center;
  }

  .sb-inp {
    border: solid 1px #999;
    background: 0 0;
    color: #fff;
    height: 34px;
    padding: ${({ theme }) => `0 ${theme.spacing.spacing50}`};
    outline: none;
    width: 187px;
    font-weight: 500;

    &::placeholder {
      ${({ theme }) => theme.typography.bodyLarge};
    }
  }

  .sb-btn {
    color: #bec0c4;
    border: solid 1px #999;
    border-left: 0;
    height: 34px;
    line-height: 34px;
    padding: ${({ theme }) => `0 ${theme.spacing.spacing50}`};
    background: transparent;
    cursor: pointer;
    text-transform: uppercase;
    ${({ theme }) => theme.typography.buttonLarge};
  }

  .sb-error {
    padding-top: ${({ theme }) => theme.spacing.spacing20};
    color: #ff0000;
  }

  .sb-success {
    padding-top: ${({ theme }) => theme.spacing.spacing20};
    color: #008000;
  }
`;

function NewsLetter() {
  const [email, updateEmail] = useState('');
  const [error, updateError] = useState('');
  const [success, updateSuccess] = useState('');
  const [isDisabled, updateDisabled] = useState(false);

  const onSubmit = (e: React.FormEvent<HTMLElement>) => {
    e.preventDefault();

    if (isDisabled) {
      return;
    }

    updateError('');
    const { status, error: errorMessage } = validateEmail(email);

    if (status === false && errorMessage !== undefined) {
      updateError(errorMessage);
      return;
    }

    updateDisabled(true);

    subscribeNewsletter(email)
      .then(({ error: errorCode, message }: { error: number; message: string }) => {
        updateDisabled(false);

        if (errorCode === 1) {
          updateError(message || TEXTS.OOPS);
          return;
        }

        updateSuccess(message);
      })
      .catch(() => {
        updateError(TEXTS.OOPS);
        updateDisabled(false);
      });
  };

  const onEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    updateEmail(e.target.value);
  };

  return (
    <SubSection title={TEXTS.SUBSCRIBE_NEWSLETTER}>
      <Container>
        <form onSubmit={onSubmit} className="sb-form">
          <input
            className="sb-inp"
            onChange={onEmailChange}
            placeholder={TEXTS.ENTER_EMAIL}
            aria-label={TEXTS.ENTER_EMAIL}
          />
          <button className="sb-btn">{TEXTS.SUBMIT}</button>
        </form>
        {error.length > 0 && <div className="sb-error">{error}</div>}
        {success.length > 0 && <div className="sb-success">{success}</div>}
      </Container>
    </SubSection>
  );
}

export default memo(NewsLetter);
